import { all } from "redux-saga/effects";
import loginSaga from "../../views/Login/ducks/saga";
import userSaga from "../../views/Users/ducks/saga";
import dashboardSaga from "../../views/Dashboard/ducks/saga";

export default function* rootSaga() {
  yield all([loginSaga(), userSaga(), dashboardSaga()]);
}
